<template>
    <div>
      <!-- Popup principal -->
      <div v-if="showMainPopup" class="cookie-consent-popup show">
        <button class="cookie-close-btn" @click="closeMainPopup" aria-label="Fermer">×</button>
        <div class="cookie-consent-content">
            <h5 class="cookie-consent-title">Gérer le consentement aux cookies</h5>
            <p class="cookie-consent-text">
            Nous utilisons des cookies essentiels pour faire fonctionner notre site. 
            Avec votre consentement, nous pouvons également utiliser des cookies non essentiels 
            pour améliorer l'expérience utilisateur et analyser le trafic sur notre site web. 
            En cliquant sur "Accepter", vous acceptez l'utilisation de tous les cookies sur notre site web, 
            conformément à la description fournie dans notre 
            <a href="https://www.mysimplyagenda.com/Politique_de_confidentialite_FO_My_Simply_Agenda.pdf" target="_blank" class="cookie-link">politique relative aux cookies</a>. 
            Vous pouvez modifier vos paramètres d'acceptation des cookies à tout moment en cliquant sur "Gérer les cookies".
            </p>
            <div class="cookie-consent-buttons">
                <button type="button" class="btn btn-outline-primary btn-custom" @click="openManagePopup">
                  Gérer les cookies
                </button>
                <button type="button" class="btn btn-primary btn-accept" @click="acceptCookies">
                  Accepter
                </button>
            </div>
        </div>
      </div>
  
      <!-- Popup de gestion -->
      <div v-if="showManagePopup" class="cookie-manage-consent-popup show">
        <button class="cookie-close-btn" @click="closeManagePopup" aria-label="Fermer">×</button>
        <div class="cookie-consent-content">
          <h5 class="cookie-consent-title">Gérer vos cookies</h5>
          <p class="cookie-consent-text">
            Pour l'instant, on utilise que des cookies essentiels pour faire fonctionner notre site.
          </p>
          <div class="cookie-options">
            <div>
              <input type="checkbox" id="cookie_necessary" checked disabled>
              <label for="cookie_necessary">Essentiel</label>
            </div>
          </div>
          <div class="cookie-consent-buttons">
            <button type="button" class="btn btn-outline-primary btn-refuser" @click="closeManagePopup">
              Annuler
            </button>
            <button type="button" class="btn btn-primary btn-accept" @click="savePreferences">
              Enregistrer
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { ref, onMounted } from 'vue'
  import { Inertia } from '@inertiajs/inertia'
  
  export default {
    name: 'CookieConsent',
    
    setup() {
      const showMainPopup = ref(false)
      const showManagePopup = ref(false)
  
      // Helpers cookies
      const setCookie = (name, value, days) => {
        const d = new Date()
        d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000))
        document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/;SameSite=Lax`
      }
  
      const getCookie = (name) => {
        const nameEQ = name + "="
        const ca = document.cookie.split(';')
        for (let c of ca) {
          while (c.charAt(0) === ' ') c = c.substring(1)
          if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length)
        }
        return null
      }
  
      const getVisitorId = () => {
        if (typeof window === 'undefined') return null
        
        let visitorId = localStorage.getItem('visitor_id')
        if (!visitorId) {
          visitorId = crypto.randomUUID()
          localStorage.setItem('visitor_id', visitorId)
        }
        return visitorId
      }
  
      const sendConsentToServer = async (consentData) => {
        try {
          const response = await fetch('/api/cookie-consent', {
            method: 'POST',
            headers: { 
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              visitor_id: getVisitorId(),
              consent_data: consentData,
              policy_version: '1.0'
            })
          })
          const res = await response.json()
          console.log('Consentement enregistré:', res)
        } catch (err) {
          console.error('Erreur lors de l\'enregistrement:', err)
        }
      }
  
      const checkConsent = async () => {
        const localConsent = getCookie('cookieConsent')
        
        if (localConsent) {
          return
        }
        
        try {
          const response = await fetch('/api/cookie-consent/check', {
            method: 'POST',
            headers: { 
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              visitor_id: getVisitorId()
            })
          })
          
          const data = await response.json()
          
          if (data.has_consent) {
            console.log('Consentement trouvé sur le serveur')
            setCookie('cookieConsent', '1', 365)
            
            if (data.consent_data) {
              setCookie('cookieConsentData', JSON.stringify(data.consent_data), 365)
            }
          } else {
            showMainPopup.value = true
          }
        } catch (error) {
          console.error('Erreur:', error)
          showMainPopup.value = true
        }
      }
  
      const acceptCookies = () => {
        const consentData = { 
          necessary: true, 
          preferences: false, 
          analytics: false, 
          marketing: false 
        }
        
        setCookie('cookieConsent', '1', 365)
        setCookie('cookieConsentData', JSON.stringify(consentData), 365)
        sendConsentToServer(consentData)
        showMainPopup.value = false
      }
  
      const closeMainPopup = () => {
        const consentData = { 
          necessary: true, 
          preferences: false, 
          analytics: false, 
          marketing: false 
        }
        setCookie('cookieConsent', '1', 365)
        setCookie('cookieConsentData', JSON.stringify(consentData), 365)
        sendConsentToServer(consentData)
        showMainPopup.value = false
      }
  
      const openManagePopup = () => {
        showMainPopup.value = false
        showManagePopup.value = true
      }
  
      const closeManagePopup = () => {
        showManagePopup.value = false
        showMainPopup.value = true
      }
  
      const savePreferences = () => {
        const consentData = {
          necessary: true,
          preferences: false,
          analytics: false,
          marketing: false
        }
        
        setCookie('cookieConsent', '1', 365)
        setCookie('cookieConsentData', JSON.stringify(consentData), 365)
        sendConsentToServer(consentData)
        showManagePopup.value = false
      }
  
      onMounted(() => {
        checkConsent()
      })
  
      return {
        showMainPopup,
        showManagePopup,
        acceptCookies,
        closeMainPopup,
        openManagePopup,
        closeManagePopup,
        savePreferences
      }
    }
  }
  </script>
  
  <style scoped>
  .cookie-consent-popup {
    position: fixed;
    bottom: 20px;
    left: 50%;
    /* transform: translateX(-50%); */
    background-color: #fff;
    border: 1px solid #ccc;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.2);
    z-index: 9999;
    display: none;
}

.cookie-consent-popup.show {
    display: block;
    opacity: 1 !important;
    visibility: visible !important;
    /* transform: translateX(-50%) !important; */
}

.cookie-manage-consent-popup {
    position: fixed;
    bottom: 20px;
    left: 60%;
    /* transform: translateX(-50%); */
    background-color: #fff;
    border: 1px solid #ccc;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.2);
    z-index: 9999;
    display: none;
}

.cookie-manage-consent-popup.show {
    display: block;
    opacity: 1 !important;
    visibility: visible !important;
    /* transform: translateX(-50%) !important; */
}

.cookie-consent-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 12px;
    color: #333;
}

.cookie-consent-text {
    font-size: 14px;
    line-height: 1.6;
    color: #666;
    margin-bottom: 20px;
}

.cookie-link {
    color: var(--primary-color, #007bff);
    text-decoration: underline;
}

.cookie-link:hover {
    color: var(--secondary-color, #0056b3);
}

.cookie-consent-buttons {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
}

.btn-accept {
    background: var(--primary-color, #007bff);
    color: white;
    padding: 8px 20px;
    border-radius: 6px;
    border: none;
    font-weight: 500;
    transition: all 0.3s;
    cursor: pointer;
}

.btn-accept:hover {
    background: var(--secondary-color, #0056b3);
}

.btn-refuser, .btn-custom {
    border: 2px solid var(--primary-color, #007bff);
    color: var(--primary-color, #007bff);
    background: white;
    padding: 8px 20px;
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.3s;
    cursor: pointer;
}

.btn-refuser:hover, .btn-custom:hover {
    background: var(--primary-color, #007bff);
    border: 2px solid var(--primary-color, #007bff);
    color: white;
}

.cookie-options div {
    margin-bottom: 10px;
}

.cookie-options label {
    margin-left: 8px;
    font-weight: 500;
}


.cookie-close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    background: transparent;
    border: none;
    font-size: 28px;
    line-height: 1;
    color: #999;
    cursor: pointer;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.3s;
}

.cookie-close-btn:hover {
    color: #333;
}

@media (max-width: 768px) {
    .cookie-consent-popup {
        left: 12px;
        right: 8px;
        max-width: calc(100% - 20px);
        bottom: 10px;
        transform: none;
    }

    .cookie-consent-buttons {
        flex-direction: column;
        gap: 10px;
    }

    .cookie-consent-buttons button {
        width: 100%;
    }
}  
</style>